import { Choice } from '../models/FormFieldChoice.model'
import { FormFieldDTO } from '../models/FormFieldDTO.model'
import { FormFieldTypes } from '../models/FormFieldTypes.model'
import { FormPageDTO } from '../models/FormPageDTO.model'

type FieldValues = Record<string | number, unknown>

export const WOULD_WORK_AGAIN_INPUT_NAME = 'would-work-again'
export const LAST_WORKED_INPUT_NAME = 'last-worked'
export const LAST_WORKED_MONTH_INPUT_NAME = 'last-worked-month'

export function isWrapUpVisibleField(field: FormFieldDTO): boolean {
  return field.type !== FormFieldTypes.section && field.label !== 'Scrub Color' && field.label !== 'Charting Software'
}

export function isWouldWorkAgainField(field: FormFieldDTO): boolean {
  return field.inputName === WOULD_WORK_AGAIN_INPUT_NAME
}

export function getReviewChoiceLabel(field: FormFieldDTO, choice: Choice): string {
  if (field.inputName === LAST_WORKED_INPUT_NAME) {
    const year = new Date().getFullYear()
    const labels: Record<string, string> = {
      'current-year': String(year),
      earlier: 'Earlier',
      'still-there': 'Still there',
      'year-minus-1': String(year - 1),
      'year-minus-2': String(year - 2),
    }
    return labels[choice.value] ?? choice.label
  }

  return choice.label
}

export function isGetStartedPageComplete(page: FormPageDTO, fieldValues: FieldValues): boolean {
  const requiredFields =
    page.fields?.filter((field) => field.visible && field.isRequired && field.type !== FormFieldTypes.section) ?? []

  return requiredFields.every((field) => isFieldValueAnswered(fieldValues[field.id]))
}

export function isFieldValueAnswered(value: unknown): boolean {
  return value !== undefined && value !== null && String(value).trim() !== ''
}

export function isRatingPageIndex(pageIndex: number, totalPages: number): boolean {
  return pageIndex > 0 && pageIndex < totalPages - 1
}

export function getPageScoreFields(page: FormPageDTO): FormFieldDTO[] {
  return page.fields?.filter((field) => field.visible && field.type !== FormFieldTypes.section && field.isRating) ?? []
}

export function isReviewQuestionPageComplete(page: FormPageDTO, fieldValues: FieldValues): boolean {
  const scoreFields = getPageScoreFields(page)
  if (scoreFields.length === 0) {
    return true
  }
  return scoreFields.every((field) => isFieldValueAnswered(fieldValues[field.id]))
}

export function canNavigateToReviewPage(
  targetIndex: number,
  reviewPageIndex: number,
  pages: FormPageDTO[],
  fieldValues: FieldValues,
): boolean {
  if (targetIndex === reviewPageIndex) {
    return true
  }
  if (targetIndex < reviewPageIndex) {
    return true
  }
  for (let i = 1; i < targetIndex; i++) {
    if (isRatingPageIndex(i, pages.length) && !isReviewQuestionPageComplete(pages[i], fieldValues)) {
      return false
    }
  }
  return true
}
